import { Component, OnInit } from '@angular/core';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-Nav',
  templateUrl: './Nav.component.html',
  styleUrls: ['./Nav.component.scss']
})
export class NavComponent implements OnInit {

  Type: string = "0"
  Token: String = ""
  Data_Menu: Array<Nav_Interface> = []

  NewTickerCount: number = 0

  constructor(
    private Nav_Service: NavService,

  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Type = localStorage.getItem('Daro_User_Type');

    this.Data_Menu = JSON.parse(localStorage.getItem('Daro_User_Nav'));

    this.Data_Menu = this.FilterNav(0)

    if (this.Type == '3' || this.Type == '4') {
      this.Data_Menu[0].visible = true
    }
    else {
      setTimeout(() => {
        for (let item of this.Data_Menu) {
          item.visible = false
        }
      }, 2000);
    }

    this.GetNotice()
  }

  Read_Data() {
    this.Nav_Service.Get(this.Token).subscribe(
      data => {
        this.Data_Menu = data['result']
        this.NewTickerCount = data['new_Ticket']

        this.Data_Menu = this.FilterNav(0)
        this.FilterNavParent()

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  FilterNav(id: Number): Array<Nav_Interface> {
    var tempList: Array<Nav_Interface> = []
    for (let item of this.Data_Menu) {
      if (item.parent == id) {
        var temp: Nav_Interface = Empty_Nav_Interface()
        temp.id = item.id
        temp.icon = item.icon
        temp.link = item.link
        temp.parent = item.parent
        temp.title = item.title
        temp.count = 0
        temp.visible = true
        temp.child = this.FilterNav(item.id)

        if (item.id == 1102 || item.id == 1104) {
          temp.count = this.NewTickerCount
        }

        tempList.push(temp)
      }

    }

    return tempList
  }

  FilterNavParent() {
    if (this.Type == '1' || this.Type == '2') {
      this.Data_Menu[0].visible = true

      for (let item1 of this.Data_Menu) {
        item1.count = 0
        for (let item2 of item1.child) {
          if (item2.count > 0 || item2.new)
            item1.count = 5
        }
      }
    }
  }

  Change_Visible_Menu(item: Nav_Interface) {
    item.visible = !item.visible
  }

  Set_Count_Zero(item: Nav_Interface) {
    //item.count=0
    this.GetNotice()
  }

  GetNotice() {

    this.Nav_Service.GetNotice(this.Token).subscribe(
      data => {
        for (let nav of data) {
          for (let lvl1 of this.Data_Menu) {
            for (let lvl2 of lvl1.child) {
              if (nav['id'] == lvl2.id) {

                lvl2.count = nav['parent']
                lvl2.new = nav['orderMenu']

                this.FilterNavParent()

              }
            }
          }
        }
      }
    )
  }

}
